import { FC, RefObject, useRef } from 'react';
import { PencilIcon, Tooltip, TOOLTIP_SURFACE } from '@repo/atomic-components';

interface EditClusterDateButtonProps {
  onClick: () => void;
}

/**
 * Pencil shown next to a cluster's date in the thumbnails bar. Hidden until the
 * date label is hovered — the `group/date-label` it keys off is set by
 * GroupLabel, so the whole label acts as the hover target, not just the icon.
 */
export const EditClusterDateButton: FC<EditClusterDateButtonProps> = ({ onClick }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        aria-label="Edit date"
        // The group header opens a context menu and selects pages on click;
        // neither should fire when the pencil is what was clicked.
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        onMouseDown={(e) => e.stopPropagation()}
        className="hidden shrink-0 cursor-pointer items-center p-[2px] group-hover/date-label:flex"
      >
        <PencilIcon className="text-fletchers-black-900 h-3 w-3" />
      </button>
      <Tooltip
        target={buttonRef as RefObject<HTMLElement>}
        content="Edit date"
        position="top"
        className={TOOLTIP_SURFACE}
        showDelay={0}
        hideDelay={0}
      />
    </>
  );
};
